import { faYoutube, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faHouse, faPhone, faEnvelope, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { usePage } from "@inertiajs/react";

export default function TopRibon({ topRibbon }: any) {
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');

  const itemStyle = {
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    gap: '6px',
  };

  const { sidebarData } = usePage<{ navigationData: any; sidebarData: any }>().props;
  console.log('sidebarData', sidebarData)

  if (isLarge) {
    return (
      <div style={{
        backgroundColor: 'var(--color-neutral)',
        color: 'var(--color-base-300)',
        padding: '0 20px',
        display: 'flex',
        flexDirection: 'row',
        gap: '40px',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        flexShrink: 0,
        zIndex: 1000,
      }}>
        {topRibbon.address && (
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('dayrna')}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...itemStyle, color: 'inherit', textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faHouse} />
            <span>{topRibbon.address}</span>
          </a>
        )}
        {topRibbon.phone && (
          <a
            href={`tel:${topRibbon.phone}`}
            style={{ ...itemStyle, color: 'inherit', textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faPhone} />
            <span>{topRibbon.phone}</span>
          </a>
        )}
        {topRibbon.email && (
          <a
            href={`mailto:${topRibbon.email}`}
            style={{ ...itemStyle, color: 'inherit', textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            <span>{topRibbon.email}</span>
          </a>
        )}
        <div style={{ display: 'flex', gap: '8px' }}>
          {topRibbon.youtube_url && (
            <a href={topRibbon.youtube_url} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          )}
          {topRibbon.facebook_url && (
            <a href={topRibbon.facebook_url} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          )}
        </div>
        <div style={itemStyle}>
          <FontAwesomeIcon icon={faClock} />
          <span>Messes: Lun - Sam: {sidebarData?.mass_schedule?.weekday} | Dim: {sidebarData?.mass_schedule?.sunday}</span>
        </div>
      </div>
    );
  }

  // Mobile: 3 lines
  return (
    <div style={{
      backgroundColor: 'var(--color-neutral)',
      color: 'var(--color-base-300)',
      padding: '6px 12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      width: '100%',
      flexShrink: 0,
      zIndex: 1000,
      fontSize: '0.75rem',
    }}>
      {/* Line 1: Mass times */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
        <FontAwesomeIcon icon={faClock} />
        <span>Messes: Lun - Sam: 19h00 | Dim: 9h00, 11h30, 19h00</span>
      </div>
      {/* Line 2: Address */}
      {topRibbon.address && (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('dayrna')}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center', color: 'inherit', textDecoration: 'none' }}
        >
          <FontAwesomeIcon icon={faHouse} />
          <span>{topRibbon.address}</span>
        </a>
      )}
      {/* Line 3: Contact */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
        {topRibbon.phone && (
          <a
            href={`tel:${topRibbon.phone}`}
            style={{ ...itemStyle, color: 'inherit', textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faPhone} />
            <span>{topRibbon.phone}</span>
          </a>
        )}
        {topRibbon.email && (
          <a
            href={`mailto:${topRibbon.email}`}
            style={{ ...itemStyle, color: 'inherit', textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            <span>{topRibbon.email}</span>
          </a>
        )}
        {topRibbon.youtube_url && (
          <a href={topRibbon.youtube_url} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        )}
        {topRibbon.facebook_url && (
          <a href={topRibbon.facebook_url} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        )}
      </div>
    </div>
  );
}
